/* Code generated with AutoHTML Plugin for Figma */
import { Question } from "@project/shared-types";
import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router";
import { GetQuestionsAPI } from "../../api/questionsAPi";
import Title from "../../components/texts/title";
import { _sizeHeading } from "../../core/core";
import "./faq.css";
import { QuestionView } from "./question";
export const Faq: React.FC<{ block?: { title: string } | null }> = ({
  block = null,
  ...props
}) => {
  const [questions, setQuestions] = useState<Question[]>([]);
  const { url } = useParams();
  const loading = useRef(false);
  const currentPage = useLocation();
  useEffect(() => {
    // Функция для получения карточек услуг с сервера
    const fetchQuestions = async () => {
      try {
        let faq_url = url;
        if (!faq_url) {
          faq_url = currentPage.pathname;
        }
        const response = await GetQuestionsAPI({
          is_client: true,
          url: faq_url,
        }); // Замените '/api/service-previews' на ваше API-оконечное точка для получения карточек услуг

        setQuestions(response.questions);
      } catch (error) {
        console.error("Ошибка при получении карточек услуг:", error);
      }
    };
    if (!questions || questions.length == 0 || !loading.current) {
      loading.current = true;
      fetchQuestions();
      loading.current = false;
    }
  }, []);
  return (
    <div className="faq">
      <div className="block-header">
        <Title type={_sizeHeading.h2}>
          {block ? block.title : "Частые вопросы"}
        </Title>
      </div>

      <div className="questions">
        {questions && (
          <>
            {questions.map((question) => (
              <QuestionView
                key={question.id}
                question={question}
              ></QuestionView>
            ))}
          </>
        )}
      </div>
    </div>
  );
};
